module.exports = __webpack_public_path__ + "img/Garage.b1e1e75e.jpeg";